import React from 'react';
import { Building2 } from 'lucide-react';
import clsx from 'clsx';
import styles from './DivisionNameCell.module.css';

export interface DivisionNameCellProps {
  name: string;
  className?: string;
  /** Rendered right after the name, e.g. the Future Version indicator. */
  suffix?: React.ReactNode;
}

const DivisionNameCell: React.FC<DivisionNameCellProps> = ({ name, className, suffix }) => {
  return (
    <div className={clsx(styles.nameCell, className)}>
      <Building2 size={16} className={styles.nameIcon} />
      <span>{name}</span>
      {suffix}
    </div>
  );
};

export default DivisionNameCell;
